import { AfterViewInit, Component, ElementRef, HostBinding, OnInit, ViewChild, HostListener, Renderer2, OnDestroy } from '@angular/core';

import { UrlSerializer, Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { ChatServiceService } from './_services/chatService.service';

import { trigger, state, style, animate, transition } from '@angular/animations';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Meta } from '@angular/platform-browser';
import {LowerCaseUrlSerializer} from './serializers/LowerCaseUrlSerializer';
import {EnvironmentService} from "./_services/environment.service";

declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0 })),
      transition(':enter, :leave', [
        animate(700)
      ])
    ])
  ],
  providers: [
    {
        provide: UrlSerializer,
        useClass: LowerCaseUrlSerializer
    }
],
})
export class AppComponent implements AfterViewInit, OnInit {

  // @ViewChild('footerIdentifier') footer: ElementRef;
  @ViewChild('slideInButton') slideInButton;

  isFileOnline: boolean = false;
  showingQABanner = false;

  bodyComp = document.getElementsByTagName("body")[0];
  queryParams: string;


  title = 'Assessor';
  chatText = ""
  typingText = "";

  openInterval: any;
  closeInterval: any;
  isExanded: boolean = false;



    @HostListener('window:resize', ['$event'])
    onResize(event) {
      // event.target.innerWidth;
      // console.log(event.target.innerWidth)
    //   var height = this.footer.nativeElement.offsetHeight;
    //
    // this.bodyComp.style.paddingBottom = height.toString() + 'px';

    }

    constructor(private router: Router, public chatService: ChatServiceService, private renderer: Renderer2, private elementRef: ElementRef, private translate: TranslateService, private metaService: Meta,
                private environmentService: EnvironmentService) {
      this.showingQABanner = environmentService.isQA();

      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

        this.changeLang();
        if(window.location.host != 'assessor.lacounty.gov') {
          this.metaService.addTag({ name: 'robots', content: 'noindex' });

        }


      });

      const navigation = this.router.getCurrentNavigation();

      if (navigation && navigation.extras && navigation.extras.state) {
        const state = navigation.extras.state;
        // Access the state object here
        console.log(state)
      }

      this.router.events.subscribe(event => {
        if(event instanceof NavigationEnd){

          if(event.urlAfterRedirects == '/fileonline') {
            this.isFileOnline = true;
            console.log(true)
          }

            gtag('config', 'G-K349QH6DY5',
                  {
                    'page_path': event.urlAfterRedirects
                  }
                 );
         }
      }
    )

  }
  onActivate(event) {
    window.scroll(0,0);
    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)

}
  ngAfterViewInit() {
    const element = this.elementRef.nativeElement.querySelector('.pulse-button') || this.elementRef.nativeElement;
    // var height = this.footer.nativeElement.offsetHeight;

    // this.bodyComp.style.paddingBottom = height.toString() + 'px';
    this.slideInButton.nativeElement.classList.add("slide-in");
    // this.slideInButton.nativeElement.classList.add("pulse-button")

    setTimeout(() => {
      this.renderer.removeClass(element, 'pulse-button');
    }, 3000);


  }

  onMouseOut() {
    this.slideInButton.nativeElement.classList.add("expand");
    // this.slideInButton.nativeElement.classList.remove("pulse-button")

    if(!this.isExanded)
    {
      this.isExanded = !this.isExanded
      console.log(this.isExanded)
      this.closeInterval = setInterval(() =>
      {
        if (this.typingText.length > 0) {
          this.typingText = this.typingText.substring(0, this.typingText.length - 1);
        }
        else
        {

            clearInterval(this.closeInterval);
            this.closeInterval = null;
            this.isExanded = !this.isExanded
        }

      },
      60);
      }
  }
  onMouseEnter() {
    this.slideInButton.nativeElement.classList.remove("expand")
    this.typingText = this.chatText;

  }



  ngOnInit(): void {


    this.changeLang();

  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()

    switch (true) {
      case agent.indexOf('edg') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }


  }


  changeLang():void{
    this.translate.get('ChatText').subscribe((translation: string) => {
      // console.log(translation);

      if(this.chatText == '') {
        this.chatText = translation;
        this.typingText = translation;
      }

      this.chatText = translation;
      if(this.typingText != '')
        this.typingText = translation;
    });
  }

  onDismissBanner(): void {
    this.showingQABanner = false;
  }
}
